import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n-context";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="mt-24 border-t border-border/70 bg-brand-canvas/40">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <img src="/ijff_logo.png" alt="IJFF 2026" className="h-14 w-auto mb-3" />
          <p className="text-sm text-muted-foreground mt-2 leading-relaxed">
            {t("brand")}
          </p>
        </div>
        <div className="text-sm">
          <div className="font-semibold mb-3">Event</div>
          <div className="text-muted-foreground">12 – 13 December 2026</div>
          <div className="text-muted-foreground">09:00 – 18:00</div>
          <div className="text-muted-foreground mt-2">Shiokaze Park</div>
          <div className="text-muted-foreground">Odaiba, Tokyo</div>
        </div>
        <div className="text-sm">
          <div className="font-semibold mb-3">Explore</div>
          <ul className="space-y-2 text-muted-foreground">
            <li><Link to="/map" className="hover:text-brand-red">Booth Map</Link></li>
            <li><Link to="/booth-info" className="hover:text-brand-red">Booth Pricing</Link></li>
            <li><Link to="/gallery" className="hover:text-brand-red">Gallery</Link></li>
            <li><Link to="/sponsors" className="hover:text-brand-red">Sponsorship</Link></li>
            <li><Link to="/register" className="hover:text-brand-red">Register</Link></li>
            <li><Link to="/terms" className="hover:text-brand-red">Terms & Conditions</Link></li>
          </ul>
        </div>
        <div className="text-sm">
          <div className="font-semibold mb-3">Organized by</div>
          <div className="font-medium text-foreground">Nations Bridge Event Management &amp; Planner</div>
          <div className="text-muted-foreground text-xs mt-3 uppercase tracking-widest">Contact</div>
          <a href="mailto:admin@nationsbridge.jp" className="text-brand-red hover:underline" data-testid="footer-contact-email">admin@nationsbridge.jp</a>
          <div className="text-muted-foreground text-xs mt-3 uppercase tracking-widest">Supported by</div>
          <div className="text-muted-foreground">Embassy of the Republic of Indonesia in Tokyo</div>
        </div>
      </div>
      <div className="border-t border-border/70 py-6 text-center text-xs text-muted-foreground">
        © 2026 IJFF · インドネシア・日本友好フェスティバル
      </div>
    </footer>
  );
}
